<template>
	<div class="container">
		<div class="layout-chat-main">
			<div class="chat-header" v-if="_chatObj">
				<div class="left-box">
					<div @click="onInvitation" class="ml10 invitation-btn top-public-btn" v-if="!xzConfig.isHelp">
						<i class="iconfont el-icon-share mr4"></i> 邀请协助
					</div>
					<div class="ml10 cooperation-btn top-public-btn" v-if="xzConfig.isHelp">
						<img class="icon" src="../../../static/icon/chat-header-xzz-icon.png" /> 协助中
					</div>
					<div class="ml10 cooperation-pop-btn top-public-btn" @click="reqXzUserListConfig.isShowPop = true"
						v-if="!xzConfig.isHelp">
						协作联盟
					</div>
				</div>
				<div class="center-box" v-if="xzConfig.isHelp">
					<el-popconfirm title="确认结束协助，是否继续？" @confirm="onChangeXzStatus('end')">
						<div class="end-btn top-public-btn ml10" slot="reference">
							<img class="icon" src="../../../static/icon/chat-header-end-on-icon.png" />结束
						</div>
					</el-popconfirm>
					<el-popconfirm title="确认返回协助，是否继续？" @confirm="onChangeXzStatus('return')">
						<div class="back-btn top-public-btn ml10" :class="{ active: !xzConfig.helpInfo.isAbleReturn }"
							slot="reference">
							<img class="icon" v-if="xzConfig.helpInfo.isAbleReturn"
								src="../../../static/icon/chat-header-back-on-icon.png" />
							<img class="icon" v-else src="../../../static/icon/chat-header-back-icon.png" />
							返回
						</div>
					</el-popconfirm>
				</div>
				<div class="right-box">
					<el-dropdown trigger="hover" class="user-dropdown" v-if="xzConfig.isHelp">
						<div class="xz-logo-box">
							<img class="img" :src="xzConfig.helpInfo.helpUser.avatarUrl" />
						</div>
						<el-dropdown-menu slot="dropdown">
							<div class="xz-user-dropdown-menu">
								<div class="logo-box">
									<div class="logo">
										<img class="img" :src="xzConfig.helpInfo.helpUser.avatarUrl" />
									</div>
									<div class="name-box">
										<div class="name">{{ xzConfig.helpInfo.helpUser.nickname }}</div>
										<div class="label">{{ xzConfig.helpInfo.helpUser.introduction }}</div>
									</div>
								</div>
								<div class="count">已协助次数：{{ xzConfig.helpInfo.debugChatCount }}</div>
							</div>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>

			<chat-box-v2
				id="chatbox-v2"
				ref="chatBox"
				:_chatDialogs="_chatDialogs"
				:_loading="_dialogsLoading"
			></chat-box-v2>

			<div class="chat-input">
				<!-- 顶部工具栏 -->
				<div class="opt-panel">
					<!-- 左侧：模型选择 + 上传按钮 -->
					<div class="opt-left">
						<!-- 模型选择按钮（醒目样式） -->
						<div class="model-select-btn" @click="modelDialogVisible = true">
							<span class="model-vendor-dot" :style="{ background: selectedModelColor }"></span>
							<span class="model-name">{{ selectedModelName }}</span>
							<i class="el-icon-arrow-down"></i>
						</div>

						<!-- 思考模式：isReasoning=2 可切换，isReasoning=1 固定推理徽章 -->
						<template v-if="modelDetail.isReasoning > 0">
							<div class="opt-divider"></div>
							<!-- 可选思考：开关 -->
							<el-tooltip v-if="modelDetail.isReasoning === 2" content="AI 会先推理再回答，消耗更多 token" placement="top">
								<div
									class="thinking-toggle"
									:class="{ 'thinking-toggle--on': enableThinking }"
									@click="enableThinking = !enableThinking"
								>
									<span class="thinking-icon">🧠</span>
									<span class="thinking-label">深度思考</span>
									<span class="thinking-dot" :class="{ on: enableThinking }"></span>
								</div>
							</el-tooltip>
							<!-- 固定推理：只展示标识，不可关闭 -->
							<div v-if="modelDetail.isReasoning === 1" class="thinking-fixed-badge">
								🧠 推理模式
							</div>
						</template>

						<div class="opt-divider"></div>

						<!-- 图片上传：仅 isImageRecognition=1 时显示 -->
						<el-tooltip v-if="modelDetail.isImageRecognition === 1" content="上传图片" placement="top">
							<div class="upload-btn" @click="$refs.imageInput.click()">
								<i class="el-icon-picture-outline"></i>
								<span>图片</span>
							</div>
						</el-tooltip>

						<!-- 文件上传：始终显示 -->
						<el-tooltip content="支持 txt / md / csv / docx / xlsx / pdf / pptx（≤5MB）" placement="top">
							<div class="upload-btn" @click="$refs.fileInput.click()">
								<i class="el-icon-paperclip"></i>
								<span>文件</span>
							</div>
						</el-tooltip>
					</div>

					<!-- 右侧：角色选择 + 清除记录 -->
					<div class="opt-right">
						<el-dropdown trigger="click" class="mr4">
							<div class="role-select-btn">
								选择AI角色<span v-if="selectRole.type === 'base'">：{{ selectRole.name }}</span>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="item of baseRoles" :key="item.id">
									<div class="flex role-drop-box">
										<div class="role-drop-title mr-4" @click="choooseRole(item, 'base')">
											{{ item.name }}
										</div>
									</div>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<!-- 选择协助角色（暂时隐藏）
						<el-dropdown trigger="click" class="mr4">
							<div class="role-select-btn" @click="onXzRole">
								选择协助角色<span v-if="selectRole.type === 'xz'">：{{ selectRole.name }}</span>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="item of roles" :key="item.id">
									<div class="flex role-drop-box">
										<div class="role-drop-title mr-4" @click="choooseRole(item, 'xz')">
											{{ item.name }}
										</div>
									</div>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						-->
						<div class="clean-chat-btn" @click="cleanDialogs">清除记录</div>
					</div>
				</div>

				<!-- 附件预览区 -->
				<div class="attachments" v-if="uploadedImages.length > 0 || uploadedFiles.length > 0">
					<div class="attachment-img" v-for="(img, i) in uploadedImages" :key="'img'+i">
						<img :src="img.preview" class="img-thumb" />
						<i class="el-icon-circle-close remove-btn" @click="removeImage(i)"></i>
					</div>
					<div class="attachment-file" v-for="(f, i) in uploadedFiles" :key="'file'+i">
						<i :class="fileTypeIcon(f.type)" class="file-icon"></i>
						<div class="file-info">
							<span class="file-name">{{ f.name }}</span>
							<span class="file-meta" v-if="f.meta">{{ f.meta }}</span>
						</div>
						<i class="el-icon-circle-close remove-btn" @click="removeFile(i)"></i>
					</div>
				</div>

				<!-- 文本输入区 -->
				<div class="chat-input-box">
					<div class="input-box">
						<el-input
							type="textarea"
							:disabled="!reqAiConfig.isSend"
							:autosize="{ minRows: 2, maxRows: 12 }"
							:placeholder="reqAiConfig.placeholder"
							v-model="textarea"
							resize="none"
							@keydown.enter.native.prevent.exact="send"
						></el-input>
					</div>
					<div class="send-icon">
						<img class="icon" @click="send" src="../../../static/icon/send-icon.png" />
					</div>
				</div>

	
				<!-- 隐藏的文件输入 -->
				<input
					type="file"
					ref="imageInput"
					accept="image/jpeg,image/png,image/webp,image/gif"
					multiple
					style="display:none"
					@change="onImageSelect"
				/>
				<input
					type="file"
					ref="fileInput"
					accept=".txt,.md,.csv,.docx,.xlsx,.xls,.pdf,.pptx"
					multiple
					style="display:none"
					@change="onFileSelect"
				/>
			</div>

			<!-- 协作者联盟用户弹窗 -->
			<el-dialog title="协作者联盟" :visible.sync="reqXzUserListConfig.isShowPop" width="1000px">
				<div class="xz-users-dialog">
					<div class="content">
						<div class="item" v-for="item in reqXzUserListConfig.list" :key="item.guid">
							<div class="top-box">
								<div class="logo">
									<img class="img" :src="item.avatarUrl" />
								</div>
								<div class="name-box">
									<p class="name">{{ item.nickname }}</p>
									<div class="yq-btn" @click="onInvite(item.guid)">请他协助我</div>
								</div>
							</div>
							<div class="lable">
								{{ item.introduction }}
							</div>
						</div>
					</div>
					<el-pagination background layout="prev, pager, next" :total="reqXzUserListConfig.total"
						:current-page="reqXzUserListConfig.page" @current-change="handlePageChang" class="mt20">
					</el-pagination>
				</div>
			</el-dialog>
		</div>

		<!-- 右侧参数面板 -->
		<div class="options-box">
			<div class="param-box">
				<div class="section-title">参数设置</div>

				<!-- 系统提示词 -->
				<div class="param-section">
					<div class="param-label">
						<span class="param-name">系统提示词</span>
						<el-tooltip effect="light" placement="top-start" popper-class="sys-prompt-tip">
							<div slot="content" style="max-width:260px;line-height:1.6">
								给 AI 设定角色和行为规则，<strong>每次对话开始前都会自动生效</strong>。<br><br>
								常见用法：<br>
								· 设定专业角色：「你是一位资深前端工程师」<br>
								· 固定回答语言：「请始终用英文回答」<br>
								· 限制回答风格：「回答请简洁，不超过3句话」<br>
								· 注入背景知识：「我们公司的产品名称叫 DeepCity」
							</div>
							<i class="el-icon-question param-help-icon"></i>
						</el-tooltip>
					</div>
					<div class="param-desc">为 AI 设定角色或行为规则，留空则由 AI 自由发挥</div>
					<div class="input-box mt6">
						<el-input
							class="inp"
							type="textarea"
							:rows="4"
							placeholder="例如：你是一位专业的数据分析师，擅长用通俗易懂的语言解释复杂数据，回答时请给出具体的数字和结论。"
							v-model="reqAiConfig.systemPrompt"
							resize="none"
						></el-input>
					</div>
				</div>
			</div>

			<div class="slider-box">
				<!-- 最大回复长度 -->
				<div class="item">
					<div class="param-label">
						<span class="param-name">最大回复长度</span>
						<el-tooltip effect="light" placement="top-start">
							<div slot="content" style="max-width:220px;line-height:1.6">
								限制 AI 单次回复的最大 Token 数。<br>
								Token 约等于半个汉字或 0.75 个英文单词。<br>
								数值越大，回复越完整，但也更慢、更耗费算力。
							</div>
							<i class="el-icon-question param-help-icon"></i>
						</el-tooltip>
					</div>
					<div class="slider">
						<div class="label">{{ reqAiConfig.maxOutputTokens }}</div>
						<el-slider v-model="reqAiConfig.maxOutputTokens" :max="modelDetail.maxOutputTokens || 8192" :step="1"></el-slider>
					</div>
				</div>

				<!-- 随机性（temperature） -->
				<div class="item" v-if="modelDetail.isReasoning !== 1">
					<div class="param-label">
						<span class="param-name">随机性</span>
						<el-tooltip effect="light" placement="top-start">
							<div slot="content" style="max-width:240px;line-height:1.6">
								控制 AI 回答的多样程度。<br><br>
								· <strong>0 ~ 0.3</strong>：保守稳定，适合代码、分析、摘要<br>
								· <strong>0.5 ~ 0.7</strong>：平衡（默认推荐）<br>
								· <strong>0.8 ~ 1.0</strong>：富有创意，适合写作、头脑风暴
							</div>
							<i class="el-icon-question param-help-icon"></i>
						</el-tooltip>
					</div>
					<div class="slider">
						<div class="label">{{ reqAiConfig.temperature }}</div>
						<el-slider v-model="reqAiConfig.temperature" :step="0.1" :min="0" :max="1"></el-slider>
					</div>
				</div>

				<!-- 词汇多样性（top_p） -->
				<div class="item" v-if="modelDetail.isReasoning !== 1">
					<div class="param-label">
						<span class="param-name">词汇多样性</span>
						<el-tooltip effect="light" placement="top-start">
							<div slot="content" style="max-width:240px;line-height:1.6">
								控制 AI 每步选词的范围。<br><br>
								· 值越低，AI 倾向选最常见的词，回答更简练<br>
								· 值越高，AI 会考虑更多备选词，表达更丰富<br><br>
								通常与「随机性」配合使用，两者不建议同时调到极值。
							</div>
							<i class="el-icon-question param-help-icon"></i>
						</el-tooltip>
					</div>
					<div class="slider">
						<div class="label">{{ reqAiConfig.topP }}</div>
						<el-slider v-model="reqAiConfig.topP" :step="0.1" :min="0" :max="1"></el-slider>
					</div>
				</div>
			</div>
		</div>

		<!-- 模型选择弹窗 -->
		<model-select-dialog
			:visible.sync="modelDialogVisible"
			:selected-guid="reqAiConfig.aiModelGuid"
			@select="onModelChoose"
		></model-select-dialog>
	</div>
</template>

<script>
import ChatBoxV2 from '@/views/app/layout-chat-v2/chat-box-v2.vue';
import ModelSelectDialog from '@/views/app/layout-chat-v2/ModelSelectDialog.vue';
import {
	clearLunci,
	getAiVendorListApi,
	getAiVendorModelListApi,
	getRobotRoles,
	helpRoleList,
	chatLunciHelpInfoApi,
	lunciHelpUserListApi,
	lunciSelectHelpUserApi,
	lunciOwnerUpdateStatusApi,
} from '@/apis/chat';
import { uploadImgApi, uploadDocFileApi } from '@/apis/user';
import config from '@/apis/config';
import { getToken } from '@/utils/auth';

export default {
	name: 'layout-chat-main-v2',
	components: { ChatBoxV2, ModelSelectDialog },

	props: {
		_chatDialogs:    Array,
		_chatingId:      String,
		_chatObj:        Object,
		_dialogsLoading: { type: Boolean, default: false },
	},

	async created() {
		this.connectWs();
		this.autoSelectFirstModel();
		this.baseRoles = await getRobotRoles();
		this.baseRoles.push({ name: '通用对话角色', value: '', id: 0 });
		this.getHelpRoleList();
		this.getLunciHelpUserList();
	},

	beforeDestroy() {
		this.closeWs();
	},

	data() {
		return {
			config,
			textarea:      '',
			enableThinking: false,
			modelDialogVisible:   false,
			selectedModelName:    '请选择模型',
			selectedModelVendor:  '',

			// WebSocket
			ws:               null,
			wsReconnectTimer: null,
			wsConnected:      false,

			// 断线恢复：记录当前正在流式输出的会话，用于重连后补发缺失事件
			_pendingLunci:    null,   // 正在等待回复的 chatLunciGuid
			_eventsReceived:  0,      // 本次流式已收到的事件数

			reqAiConfig: {
				aiModelGuid:    '',
				chatScene:      'default',
				sceneValue:     '',
				maxOutputTokens: 2048,
				temperature:    0.95,
				topP:           0.7,
				systemPrompt:   '',
				isMultiple:     true,
				isSend:         false,
				placeholder:    '请输入您的问题或需求，Enter 发送',
			},

			modelDetail: {
				maxOutputTokens:    2048,
				modelType:          'text',
				isImageRecognition: 0,
				isVideoRecognition: 0,
				isNetwork:          0,
				isReasoning:        0,
			},

			// 流式输出中的对话索引（-1 表示无）
			streamingIdx: -1,

			// 上传的图片列表：[{ preview: 'data:...', url: 'https://...' }]
			uploadedImages: [],
			// 上传的文件列表：[{ name: 'xxx.txt', content: '文本内容' }]
			uploadedFiles: [],
			// 图片上传中
			imageUploading: false,

			// 角色选择
			baseRoles: [],
			roles: [],
			selectRoleKey: 0,
			selectRole: { id: '', name: '通用对话角色', type: 'base' },
			isHelp: false,

			// 协助配置
			xzConfig: {
				isHelp: false,
				helpInfo: {
					helpGuid: '',
					helpUser: {
						nickname: '',
						introduction: '',
						avatarUrl: '',
					},
					isAbleReturn: false,
					debugChatCount: 0,
				},
			},

			// 协作者联盟用户列表
			reqXzUserListConfig: {
				pageSize: 6,
				page: 1,
				total: 0,
				list: [],
				isShowPop: false,
			},
		};
	},

	computed: {
		selectedModelColor() {
			const map = {
				openrouter: '#8b5cf6',
				deepseek:   '#1d4ed8',
				zhipu:      '#059669',
				openai:     '#10b981',
				azure:      '#0078d4',
				closeai:    '#7c3aed',
			};
			return map[this.selectedModelVendor] || '#aaa';
		},
	},

	watch: {
		async _chatingId() {
			this.getChatLunciHelpInfo();
			this.getHelpRoleList();
			this.reqAiConfig.systemPrompt = (this._chatObj && this._chatObj.chatLunciPrompt) ? this._chatObj.chatLunciPrompt : '';
		},
	},

	methods: {
		// ──────────────────────────────────────────────
		// 初始化：自动选中第一个可用模型
		// ──────────────────────────────────────────────
		async autoSelectFirstModel() {
			const vendorRes = await getAiVendorListApi();
			const vendors   = (vendorRes && vendorRes.data) ? vendorRes.data : [];
			if (vendors.length === 0) return;

			const modelRes = await getAiVendorModelListApi({
				modelVendorSign: vendors[0].sign,
				modelType:       'text',
			});
			const models = (modelRes && modelRes.data) ? modelRes.data : [];
			if (models.length > 0) {
				this.onModelChoose(models[0]);
				// 模型选好后允许发送
				this.reqAiConfig.isSend = this.wsConnected;
			}
		},

		// ──────────────────────────────────────────────
		// 模型选中回调（弹窗 select 事件）
		// ──────────────────────────────────────────────
		onModelChoose(item) {
			this.selectedModelName           = item.modelName;
			this.reqAiConfig.aiModelGuid     = item.guid;
			this.reqAiConfig.maxOutputTokens = item.maxOutputTokens || 2048;
			this.modelDetail = {
				maxOutputTokens:    item.maxOutputTokens    || 2048,
				modelType:          item.modelType          || 'text',
				isImageRecognition: item.isImageRecognition || 0,
				isVideoRecognition: item.isVideoRecognition || 0,
				isNetwork:          item.isNetwork          || 0,
				isReasoning:        item.isReasoning        || 0,
			};
			// 支持可选思考的模型默认自动开启
			this.enableThinking = item.isReasoning === 2;
			// 记录厂商颜色用于按钮小圆点
			this.selectedModelVendor = item.modelVendorSign || '';
		},

		// ──────────────────────────────────────────────
		// WebSocket 连接管理
		// ──────────────────────────────────────────────
		connectWs() {
			if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
				return;
			}

			this.ws = new WebSocket(config.wsUrl);

			this.ws.onopen = () => {
				this.wsConnected = true;
				if (this.reqAiConfig.aiModelGuid) {
					this.reqAiConfig.isSend = true;
				}
				if (this.wsReconnectTimer) {
					clearTimeout(this.wsReconnectTimer);
					this.wsReconnectTimer = null;
				}
				// 断线重连：如果有未完成的流式会话，请求服务端补发缺失事件
				if (this._pendingLunci) {
					this.ws.send(JSON.stringify({
						type:          'resume_chat',
						chatLunciGuid: this._pendingLunci,
						fromIdx:       this._eventsReceived,
					}));
				}
			};

			this.ws.onmessage = (e) => {
				let event;
				try { event = JSON.parse(e.data); } catch { return; }
				this.handleWsEvent(event);
			};

			this.ws.onclose = () => {
				this.wsConnected = false;
				// 注意：isSend 不立即重置，等重连后由服务端决定（pending 期间不允许发新消息）
				if (!this._pendingLunci) {
					this.reqAiConfig.isSend = false;
				}
				this.wsReconnectTimer = setTimeout(() => this.connectWs(), 3000);
			};

			this.ws.onerror = () => {
				this.wsConnected = false;
			};
		},

		closeWs() {
			if (this.wsReconnectTimer) clearTimeout(this.wsReconnectTimer);
			if (this.ws) { this.ws.close(); this.ws = null; }
		},

		// ──────────────────────────────────────────────
		// 处理 WebSocket 推送事件
		// ──────────────────────────────────────────────
		handleWsEvent(event) {
			const d = this.streamingIdx >= 0 ? this._chatDialogs[this.streamingIdx] : null;

			// 统计已收到的事件数，用于断线重连时告诉服务端从哪里补发
			if (this._pendingLunci) {
				this._eventsReceived++;
			}

			switch (event.type) {
				case 'text_chunk':
					if (d) { d.chatContent += event.content; d.isStreaming = true; }
					break;
				case 'reasoning_chunk':
					if (d) { d.reasoning = (d.reasoning || '') + event.content; d.isStreaming = true; }
					break;
				case 'tool_start':
					if (d) { d.toolLabel = event.label || `执行 ${event.toolName}...`; d.isTooling = true; }
					break;
				case 'tool_done':
					if (d) { d.isTooling = false; d.toolLabel = ''; }
					break;
				case 'structured_data':
					if (d) { d.structuredData = event.data; }
					break;
				case 'done':
					if (d) { d.isStreaming = false; d.isTooling = false; d.finished = true; }
					this.streamingIdx = -1;
					this._pendingLunci   = null;
					this._eventsReceived = 0;
					this.reqAiConfig.isSend = true;
					this.$emit('changeOnChatState', true);
					break;
				case 'error':
					if (d) { d.isStreaming = false; d.isTooling = false; d.finished = true; d.isError = true; d.chatContent = '❌ ' + event.message; }
					this.streamingIdx = -1;
					this._pendingLunci   = null;
					this._eventsReceived = 0;
					this.reqAiConfig.isSend = true;
					this.$emit('changeOnChatState', true);
					this.$message({ message: event.message, type: 'error' });
					break;
				case 'resume_not_found':
					// 服务端没有可恢复的 session（已完成或过期），恢复正常发送状态
					this._pendingLunci   = null;
					this._eventsReceived = 0;
					this.reqAiConfig.isSend = true;
					break;
			}
		},

		// ──────────────────────────────────────────────
		// 发送消息
		// ──────────────────────────────────────────────
		async send() {
			const content = this.textarea.trim();

			// fileUrls：COS URL 数组，PHP 负责下载解析，前端不再嵌入文件内容
			const fileUrls = this.uploadedFiles.map(f => ({ name: f.name, url: f.url, type: f.type }));

			// 用户没输入文字但有文件时也允许发送
			if (!content && fileUrls.length === 0) return;
			if (!this.reqAiConfig.isSend) return;
			if (!this.reqAiConfig.aiModelGuid) {
				this.$message({ message: '请先选择 AI 模型', type: 'warning' });
				this.modelDialogVisible = true;
				return;
			}
			if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
				this.$message({ message: 'WebSocket 未连接，正在重连...', type: 'warning' });
				this.connectWs();
				return;
			}

			// 图片预览（显示在对话气泡中）
			const imgPreviews = this.uploadedImages.map(img => img.preview);
			// 图片URL（发给 AI 的正式 URL，已上传到 COS）
			const imgs = this.uploadedImages.map(img => img.url);

			this.$emit('appendDialog', {
				chatRole:       'user',
				chatContent:    content,
				displayContent: content,
				imgUrls:        imgPreviews,
				files:          fileUrls,
				finished:       true,
				isStreaming:    false,
			});
			this.$emit('appendDialog', {
				chatRole:       'assistant',
				chatContent:    '',
				reasoning:      '',
				finished:       false,
				isStreaming:    true,
				isTooling:      false,
				toolLabel:      '',
				structuredData: null,
				isError:        false,
			});

			this.streamingIdx    = this._chatDialogs.length - 1;
			this._pendingLunci   = this._chatingId || null;
			this._eventsReceived = 0;
			this.textarea     = '';
			this.uploadedImages = [];
			this.uploadedFiles  = [];
			this.reqAiConfig.isSend = false;
			this.$emit('changeOnChatState', false);

			this.ws.send(JSON.stringify({
				type:           'send_message',
				content,
				imgs,
				fileUrls,
				chatLunciGuid:  this._chatingId || '',
				aiModelGuid:    this.reqAiConfig.aiModelGuid,
				chatScene:      this.reqAiConfig.chatScene,
				sceneValue:     this.reqAiConfig.sceneValue,
				lastMsgId:      '',
				token:          getToken(),
				app_type:       'xiaoyipc',
				app_guid:       this.$store.state.merchantGuid || '',
				enableThinking: this.enableThinking,
				temperature:    this.reqAiConfig.temperature,
				topP:           this.reqAiConfig.topP,
				maxOutputTokens: this.reqAiConfig.maxOutputTokens,
				systemPrompt:   this.reqAiConfig.systemPrompt,
				isMultiple:     this.reqAiConfig.isMultiple ? 1 : 0,
				roleId:         this.selectRoleKey,
				roleType:       this.isHelp ? '2' : '1',
			}));

			this.$nextTick(() => {
				if (this.$refs.chatBox) this.$refs.chatBox.scrollToBottom();
			});
		},

		// ──────────────────────────────────────────────
		// 图片上传：选文件 → 上传 COS → 保存 URL
		// ──────────────────────────────────────────────
		async onImageSelect(e) {
			const files = Array.from(e.target.files);
			e.target.value = '';
			if (files.length === 0) return;

			this.imageUploading = true;
			const loading = this.$loading({ text: '图片上传中...', background: 'rgba(0,0,0,0.2)' });

			try {
				for (const file of files) {
					// 本地预览
					const preview = await new Promise(resolve => {
						const reader = new FileReader();
						reader.onload = ev => resolve(ev.target.result);
						reader.readAsDataURL(file);
					});

					// 上传到 COS
					const res = await uploadImgApi(file);
					if (res && res.code === 0 && res.data) {
						const url = res.data.url || res.data;
						this.uploadedImages.push({ preview, url });
					} else {
						this.$message({ message: `图片上传失败：${res?.msg || '未知错误'}`, type: 'error' });
					}
				}
			} catch (err) {
				this.$message({ message: '图片上传失败，请重试', type: 'error' });
			} finally {
				loading.close();
				this.imageUploading = false;
			}
		},

		// ──────────────────────────────────────────────
		// 文件上传：解析文件内容，追加到消息正文
		// 支持 txt/md/csv（文本）、docx（mammoth 提取文本）、xlsx/xls（SheetJS 转表格）
		// ──────────────────────────────────────────────
		// 文件上传：上传到 COS，把 URL 存入 uploadedFiles
		// 解析工作完全交给 PHP 后端处理
		// ──────────────────────────────────────────────
		async onFileSelect(e) {
			const files = Array.from(e.target.files);
			e.target.value = '';
			if (files.length === 0) return;

			const SUPPORTED = ['txt', 'md', 'csv', 'docx', 'xlsx', 'xls', 'pdf', 'pptx'];
			const MAX_SIZE  = 5 * 1024 * 1024; // 5MB

			const loading = this.$loading({ text: '文件上传中...', background: 'rgba(0,0,0,0.15)' });
			try {
				for (const file of files) {
					const ext = file.name.split('.').pop().toLowerCase();

					if (!SUPPORTED.includes(ext)) {
						this.$message({ message: `不支持 .${ext} 格式`, type: 'warning' });
						continue;
					}
					if (file.size > MAX_SIZE) {
						this.$message({ message: `${file.name} 超过 5MB 限制`, type: 'warning' });
						continue;
					}

					const res = await uploadDocFileApi(file);
					if (res && res.code === 0 && res.data) {
						const url = res.data.url || res.data;
						this.uploadedFiles.push({ name: file.name, url, type: ext });
					} else {
						this.$message({ message: `${file.name} 上传失败：${res?.msg || '未知错误'}`, type: 'error' });
					}
				}
			} catch (err) {
				this.$message({ message: `文件上传失败：${err.message}`, type: 'error' });
			} finally {
				loading.close();
			}
		},

		// 根据文件类型返回图标类名
		fileTypeIcon(type) {
			const map = {
				xlsx: 'el-icon-document',
				xls:  'el-icon-document',
				docx: 'el-icon-document',
				csv:  'el-icon-document',
				txt:  'el-icon-document',
				md:   'el-icon-document',
			};
			return map[type] || 'el-icon-paperclip';
		},

		removeImage(i) { this.uploadedImages.splice(i, 1); },
		removeFile(i)  { this.uploadedFiles.splice(i, 1); },

		// ──────────────────────────────────────────────
		// 邀请协助 / 协作功能
		// ──────────────────────────────────────────────
		onInvitation() {
			const guid = this._chatObj.guid;
			const yqUrl = `${window.location.origin}/app/chat?yqGuid=${guid}`;
			this.$copyText(yqUrl);
			this.$message({ message: '已复制邀请链接', type: 'success' });
		},

		async onChangeXzStatus(status) {
			if (status === 'end') {
				try {
					const res = await lunciOwnerUpdateStatusApi({ chatLunciGuid: this._chatingId, status });
					this.$message({ message: res.code == 0 ? '结束协助' : res.msg, type: res.code == 0 ? 'success' : 'info' });
					this.getChatLunciHelpInfo();
				} catch (error) {
					this.$message({ message: error.msg, type: 'info' });
				}
			} else if (this.xzConfig.helpInfo.isAbleReturn) {
				try {
					const res = await lunciOwnerUpdateStatusApi({ chatLunciGuid: this._chatingId, status });
					this.$message({ message: res.code == 0 ? '返回成功' : res.msg, type: res.code == 0 ? 'success' : 'info' });
					this.getChatLunciHelpInfo();
				} catch (error) {
					this.$message({ message: error.msg, type: 'info' });
				}
			}
		},

		async onInvite(guid) {
			try {
				const res = await lunciSelectHelpUserApi({ chatLunciGuid: this._chatingId, helpUserGuid: guid });
				if (res.code == 0) {
					this.$message({ message: '邀请成功', type: 'success' });
					this.reqXzUserListConfig.isShowPop = false;
					this.getChatLunciHelpInfo();
				} else {
					this.$message({ message: res.msg, type: 'info' });
				}
			} catch (error) {
				this.$message({ message: error.msg, type: 'info' });
			}
		},

		async getLunciHelpUserList() {
			const res = await lunciHelpUserListApi(this.reqXzUserListConfig);
			this.reqXzUserListConfig.list  = res.data.data;
			this.reqXzUserListConfig.total = res.data.total;
		},

		async handlePageChang(page) {
			this.reqXzUserListConfig.page = page;
			this.getLunciHelpUserList();
		},

		async getChatLunciHelpInfo() {
			if (!this._chatingId) return;
			const res = await chatLunciHelpInfoApi({ chatLunciGuid: this._chatingId });
			if (res.code === 0) {
				this.xzConfig.isHelp = res.data.isHelp;
				if (res.data.isHelp) {
					this.xzConfig.helpInfo = res.data.helpInfo;
				}
			}
		},

		// ──────────────────────────────────────────────
		// 角色选择
		// ──────────────────────────────────────────────
		async getHelpRoleList() {
			if (!this._chatingId) return;
			const res = await helpRoleList({ chatLunciGuid: this._chatingId });
			const list = res.data.map(item => ({
				id:       item.sysId,
				name:     item.showRoleName,
				isHelp:   true,
				isDelete: item.isDelete,
				isEdit:   item.isEdit,
			}));
			this.roles = list;
		},

		choooseRole(role, type) {
			if (role.isHelp) { this.isHelp = true; }
			this.selectRoleKey = role.id;
			if (type === 'xz') {
				this.selectRole = { ...this.roles.find(item => item.id == role.id), type };
			} else {
				this.selectRole = { ...this.baseRoles.find(item => item.id == role.id), type };
			}
		},

		onXzRole() {
			if (this.roles.length === 0) {
				this.$message({ message: '暂无可协助角色', type: 'info' });
			}
		},

		cleanDialogs() {
			if (!this._chatingId) return;
			this.$confirm('确认清除本轮聊天记录？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText:  '取消',
				type:              'warning',
			}).then(async () => {
				await clearLunci(this._chatingId);
				this.$emit('clearChatDialogs');
			}).catch(() => {});
		},
	},
};
</script>

<style lang="scss" scoped>
.container {
	display: flex;
	width: 100%;
	height: 100%;

	.slider-box {
		margin-top: 20px;

		.slider {
			position: relative;

			.label {
				position: absolute;
				bottom: 30px;
				right: 0;
				color: #333333;
				font-size: 12px;
			}
		}
	}

	.options-box {
		padding: 20px;
		box-sizing: border-box;
		width: 300px;
		height: 100%;
		border-left: 1px solid #ebebeb;
		overflow-y: auto;

		.section-title {
			font-size: 11px;
			color: #999;
			font-weight: 500;
			letter-spacing: 0.5px;
			text-transform: uppercase;
		}

		.param-section {
			margin-top: 14px;
		}

		.param-label {
			display: flex;
			align-items: center;
			gap: 5px;

			.param-name {
				font-size: 13px;
				font-weight: 500;
				color: #333;
			}

			.param-help-icon {
				font-size: 13px;
				color: #bbb;
				cursor: pointer;
				transition: color 0.15s;

				&:hover { color: #6126F5; }
			}
		}

		.param-desc {
			font-size: 11px;
			color: #aaa;
			margin-top: 3px;
			line-height: 1.5;
		}

		.input-box {
			position: relative;

			.inp {
				width: 100%;
			}
		}

		.mt6 { margin-top: 6px; }
	}
}

.layout-chat-main {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;

	.chat-header {
		border-bottom: 1px solid var(--border-color);
		padding: 14px 20px;
		display: flex;
		align-items: center;
	}

	.chat-box {
		flex: 1;
		overflow: auto;
		padding: 10px 0;
	}

	.chat-input {
		border-top: 1px solid var(--border-color);
		padding: 10px 20px;
	}

	/* opt-panel：模型选择 + 上传按钮 + 清除 */
	.opt-panel {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.opt-left {
		display: flex;
		align-items: center;
		gap: 0;
	}

	.opt-right {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.opt-divider {
		width: 1px;
		height: 16px;
		background: #e0e0e0;
		margin: 0 8px;
	}
}

/* 模型选择按钮（醒目样式） */
.model-select-btn {
	display: flex;
	align-items: center;
	gap: 6px;
	height: 32px;
	padding: 0 14px;
	border-radius: 8px;
	border: 1.5px solid #c4b5fd;
	font-size: 13px;
	font-weight: 500;
	color: #5b21b6;
	background: linear-gradient(135deg, #faf5ff 0%, #ede9fe 100%);
	cursor: pointer;
	transition: all 0.2s;
	user-select: none;
	max-width: 220px;
	box-shadow: 0 1px 4px rgba(97, 38, 245, 0.1);

	&:hover {
		border-color: #6126F5;
		background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
		box-shadow: 0 2px 8px rgba(97, 38, 245, 0.18);
	}

	.model-vendor-dot {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		flex-shrink: 0;
	}

	.model-name {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}

/* 思考模式内联开关 */
.thinking-toggle {
	display: flex;
	align-items: center;
	gap: 5px;
	height: 28px;
	padding: 0 10px;
	border-radius: 6px;
	border: 1.5px solid #e0e0e0;
	background: #fff;
	cursor: pointer;
	font-size: 12px;
	color: #888;
	transition: all 0.18s;
	user-select: none;

	.thinking-icon { font-size: 13px; line-height: 1; }
	.thinking-label { white-space: nowrap; }

	.thinking-dot {
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background: #ddd;
		flex-shrink: 0;
		transition: background 0.18s;

		&.on { background: #6126F5; }
	}

	&:hover {
		border-color: #b39dfa;
		color: #6126F5;
	}

	&.thinking-toggle--on {
		border-color: #6126F5;
		background: #f5f0ff;
		color: #6126F5;
		font-weight: 500;
	}
}

/* 固定推理徽章（isReasoning=1，不可关闭） */
.thinking-fixed-badge {
	display: flex;
	align-items: center;
	height: 26px;
	padding: 0 10px;
	border-radius: 13px;
	background: #fff7e6;
	border: 1px solid #ffd591;
	font-size: 11px;
	color: #d46b08;
	white-space: nowrap;
	user-select: none;
}

/* 上传按钮（图片 / 文件） */
.upload-btn {
	display: flex;
	align-items: center;
	gap: 4px;
	height: 28px;
	padding: 0 10px;
	border-radius: 6px;
	font-size: 12px;
	color: #666;
	cursor: pointer;
	transition: background 0.15s, color 0.15s;
	user-select: none;

	i { font-size: 14px; }

	&:hover {
		background: rgba(97, 38, 245, 0.07);
		color: #6126F5;
	}
}

/* 附件预览区 */
.attachments {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding: 8px 0 4px;

	.attachment-img {
		position: relative;
		.img-thumb {
			width: 60px;
			height: 60px;
			object-fit: cover;
			border-radius: 6px;
			border: 1px solid #e0e0e0;
			display: block;
		}
	}

	.attachment-file {
		display: flex;
		align-items: center;
		gap: 5px;
		height: auto;
		min-height: 36px;
		padding: 4px 10px;
		padding: 0 10px;
		border-radius: 6px;
		border: 1px solid #e0e0e0;
		background: #f8f8f8;
		position: relative;

		.file-icon { color: #6126F5; font-size: 15px; flex-shrink: 0; }
		.file-info {
			display: flex;
			flex-direction: column;
			min-width: 0;
		}
		.file-name { font-size: 12px; color: #444; max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.file-meta { font-size: 11px; color: #999; white-space: nowrap; }
	}

	.remove-btn {
		position: absolute;
		top: -7px;
		right: -7px;
		font-size: 16px;
		color: #bbb;
		cursor: pointer;
		background: #fff;
		border-radius: 50%;
		line-height: 1;
		&:hover { color: #f56c6c; }
	}
}

/* 深度思考开关（已移至右侧面板，保留兜底样式） */
.thinking-toggle {
	&--disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}

	&--active .thinking-label {
		color: #6126F5;
		font-weight: 500;
	}
}

.chat-input-box {
	display: flex;
	gap: 10px;

	.input-box {
		flex: 1;
	}

	.send-icon {
		width: 40px;
		display: flex;
		align-items: center;
		justify-content: center;

		.icon {
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}
}

.mr4 { margin-right: 4px; }
.ml4 { margin-left: 4px; }
.mt10 { margin-top: 10px; }
.ml10 { margin-left: 10px; }
.mt20 { margin-top: 20px; }
.flex { display: flex; }

/* 顶部 header 按钮组 */
.layout-chat-main {
	.chat-header {
		.left-box {
			display: flex;

			.top-public-btn {
				width: 111px;
				height: 36px;
				border-radius: 20px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 12px;

				.icon {
					display: block;
					width: 20px;
					height: 20px;
					margin-right: 4px;
				}
			}

			.cooperation-btn {
				border: 1px solid #ff7600;
				color: #ff7600;
			}

			.cooperation-pop-btn {
				border: 1px solid #ff7600;
				color: #ff7600;
				cursor: pointer;
			}

			.invitation-btn {
				border: 1px solid #dee0e4;
				color: #737b8d;
				cursor: pointer;
			}
		}

		.center-box {
			display: flex;
			flex: 1;
			justify-content: flex-end;

			.top-public-btn {
				width: 111px;
				height: 36px;
				border-radius: 20px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 12px;
				cursor: pointer;

				.icon {
					display: block;
					width: 20px;
					height: 20px;
					margin-right: 4px;
				}
			}

			.end-btn {
				background: linear-gradient(91deg, #fe6947 0%, #fd462e 100%);
				color: #ffffff;
			}

			.back-btn {
				background: linear-gradient(270deg, #145bec 0%, #3670f8 100%);
				color: #ffffff;

				&.active {
					background: #f6f7f9;
					color: #999999;
					cursor: not-allowed;
				}
			}
		}

		.right-box {
			.xz-logo-box {
				margin-left: 20px;

				.img {
					width: 40px;
					height: 40px;
					display: block;
					border-radius: 50%;
				}
			}
		}
	}
}

/* 角色选择按钮 */
.role-select-btn {
	border-radius: 8px;
	border: 1px solid #dee0e4;
	font-size: 12px;
	color: #737b8d;
	cursor: pointer;
	padding: 6px 10px;
	width: 160px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

	&:hover {
		border-color: #f6f7f9;
		background: #f6f7f9;
	}
}

/* 协作者联盟弹窗 */
.xz-user-dropdown-menu {
	width: 300px;
	padding: 10px 20px;
	box-sizing: border-box;

	.logo-box {
		display: flex;

		.logo .img {
			width: 40px;
			height: 40px;
			display: block;
			border-radius: 50%;
		}

		.name-box {
			padding-left: 16px;

			.name {
				color: #6126f5;
				font-size: 16px;
			}

			.label {
				font-size: 14px;
				color: #333;
				margin-top: 3px;
			}
		}
	}

	.count {
		font-size: 16px;
		color: #333333;
		margin-top: 16px;
	}
}

::v-deep .el-dialog__body {
	padding: 10px 20px 20px 20px;
}

.xz-users-dialog {
	.content {
		display: flex;
		flex-wrap: wrap;

		.item {
			width: 300px;
			height: 180px;
			background: linear-gradient(#ffffff 0%, #ecebf7 100%);
			border-radius: 8px;
			border: 1px solid #ecebf7;
			padding: 15px;
			box-sizing: border-box;
			margin-right: 20px;
			margin-bottom: 20px;

			.top-box {
				display: flex;

				.logo .img {
					width: 73px;
					height: 70px;
					display: block;
				}

				.name-box {
					margin-left: 10px;

					.name {
						font-weight: 600;
						font-size: 20px;
						color: #333333;
					}

					.yq-btn {
						background: linear-gradient(90deg, #9854ec 0%, #4e58ec 53%, #145bec 100%);
						border-radius: 4px;
						color: #ffffff;
						padding: 6px 10px;
						cursor: pointer;
						margin-top: 10px;
						width: fit-content;
					}
				}
			}

			.lable {
				font-size: 13px;
				padding: 10px 0;
				height: 80px;
				color: #666666;
				overflow-y: auto;
				box-sizing: border-box;
				line-height: 1.5;
			}
		}
	}
}
</style>
